import type { VRM } from '@pixiv/three-vrm'
import { useEffect } from 'react'
import type { ExpressionSetting } from '../types'

/**
 * @todo 口や眉毛などパーツ単位で変更を指定できるようにする
 * @see https://qiita.com/nobrin/items/9085fed1ef5b8b508290#%E3%82%AB%E3%82%B9%E3%82%BF%E3%83%A0%E8%A1%A8%E6%83%85%E3%81%AE%E8%BF%BD%E5%8A%A0
 */

type UseExpressionsParams = {
  vrm: VRM | undefined
  expressions?: ExpressionSetting[]
  readyToApply: boolean
}
export const useExpressions = ({ vrm, expressions = [], readyToApply }: UseExpressionsParams) => {
  useEffect(() => {
    if (vrm?.expressionManager && readyToApply) {
      vrm.expressionManager.resetValues()
      for (const { key, weight } of expressions) {
        vrm.expressionManager.setValue(key, weight)
      }
      vrm.expressionManager.update()
    }
  }, [vrm, expressions, readyToApply])
}
